import { Check } from 'lucide-react';

type Data = {
  title: string;
  desc: string;
  tags: string[];
};
export default function Header({ data }: { data?: Data }) {
  return (
    <section className="max-w-[910px] px-4 mx-auto pt-[136px] text-center primary-text">
      <h1 className="text-[--primary-color] font-bold text-[42px]">{data?.title}</h1>
      <p className="primary-text-60 text-[20px] leading-7 pt-9">{data?.desc}</p>
      <div className="pt-9 grid grid-cols-4 gap-4 max-md:grid-cols-2">
        {data?.tags?.map((tag) => (
          <div className="flex-center" key={tag}>
            <Check size={18} className="mr-2 text-[#38C13D]" />
            <span>{tag}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
